import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { SERVER_URL } from './config';
import './InvitationResponse.css';

const GeneralInvitation = () => {
  const { slug } = useParams();
  const [bride, setBride] = useState('');
  const [groom, setGroom] = useState('');
  const [hall, setHall] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const [guestCount, setGuestCount] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phonePrefix, setPhonePrefix] = useState('050');
  const [phoneRest, setPhoneRest] = useState('');
  const [relationship, setRelationship] = useState('');

  const [note, setNote] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    axios.get(`${SERVER_URL}invitation/event-info/${slug}/`)
      .then(res => {
        setBride(res.data.bride);
        setGroom(res.data.groom);
        setHall(res.data.hall);
        setDate(res.data.date);
        setTime(res.data.time);
      })
      .catch(() => alert("שגיאה בטעינת פרטי האירוע"));
  }, [slug]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const fullName = `${firstName.trim()} ${lastName.trim()}`;
    const fullPhone = `${phonePrefix}${phoneRest}`;
  
    if (!firstName || !lastName) {
      alert("נא למלא את השם הפרטי והמשפחה");
      return;
    }
  
    if (!phoneRest || phoneRest.length !== 7) {
      alert("מספר הטלפון חייב לכלול בדיוק 10 ספרות (3 קידומת + 7 ספרות)");
      return;
    }
  
    if (guestCount === '' || Number(guestCount) < 1) {
      alert("יש להזין כמה אנשים יגיעו (לפחות 1)");
      return;
    }

    if (!relationship) {
      alert("נא לבחור את הקשר שלך לזוג");
      return;
    }    
  
    axios.post(`${SERVER_URL}invitation/general/${slug}/`, {
      name: fullName,
      phone: fullPhone,
      arriving: guestCount,
      note,
      relationship,
    }).then(() => {
      alert("נרשמת בהצלחה!");
      setSubmitted(true);
    }).catch(() => {
      alert("שגיאה בשליחה. נא לנסות שוב מאוחר יותר.");
    });
  };
   
  if (submitted) return <div className="invitation-container"><h2>מחכים לראותכם! 💖</h2></div>;

  return (
    <div className="invitation-container">
      <h1>💍 הנכם מוזמנים לחתונה של {groom} ו-{bride} 💍</h1>
      <p className="invitation-details">
        אנו שמחים להזמינכם לחגוג עמנו באולם {hall} ב־{date} בשעה {time}.
      </p>

      <form onSubmit={handleSubmit} className="response-form">
        <h2>אשרו את הגעתכם</h2>

        <label>
  <span>שם פרטי</span>
  <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required />
</label>

<label>
  <span>שם משפחה</span>
  <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} required />
</label>

<label>
  <span>מספר טלפון</span>
  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
    <select value={phonePrefix} onChange={e => setPhonePrefix(e.target.value)} required>
      <option value="050">050</option>
      <option value="052">052</option>
      <option value="053">053</option>
      <option value="054">054</option>
      <option value="055">055</option>
      <option value="058">058</option>
    </select>
    <input
      type="text"
      value={phoneRest}
      onChange={e => {
        const val = e.target.value.replace(/\D/g, '').slice(0, 7); // רק ספרות, עד 7
        setPhoneRest(val);
      }}
      placeholder="1234567"
      required
    />
  </div>
</label>
        <label>
          <span>כמה תגיעו?</span>
              <input
  type="number"
  inputMode="numeric"
  pattern="\d*"
  min="1"
  value={guestCount}
  onChange={(e) => setGuestCount(e.target.value)}
  autoFocus
/>
            </label>
            <label>
  <span>מה הקשר שלך לזוג?</span>
  <select
    value={relationship}
    onChange={e => setRelationship(e.target.value)}
    required
  >
    <option value="">בחר קשר</option>
    <option value="חברים חתן">חברים חתן</option>
    <option value="חברים כלה">חברים כלה</option>
    <option value="חברים הורים">חברים הורים</option>
    <option value="משפחה חתן">משפחה חתן</option>
    <option value="משפחה כלה">משפחה כלה</option>
    <option value="אחר">אחר</option>
  </select>
</label>

        <label>
          <span>הערות (מוגבל ל־30 תווים)</span>
          <textarea
            value={note}
            onChange={e => {
              if (e.target.value.length <= 30) setNote(e.target.value);
            }}
            maxLength={30}
            placeholder="כתבו כאן..."
          />
        </label>

        <button type="submit">שלחו תשובה</button>
      </form>
    </div>
  );
};

export default GeneralInvitation;
